import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {IProfileSpec, IProfileUser} from "../../types/profileTypes";
import {authAction} from "../../../auth/authSlice";
import {fetchTwilioToken} from "../../../chatItem/services/fetchTwilioToken/fetchTwilioToken";
import {snackbarAction} from "../../../errors/SnackbarSlice";
import {UserGroup} from "../../types/profileTypes";
import {removeToken} from "../../../auth/services/tokenManagement/tokenManagement";


export const fetchProfileSelf = createAsyncThunk<IProfileSpec | IProfileUser,
    string,
    ThunkConfig<string>>(
        'profile/fetchProfileSelf',
        async (token, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            const {changeIsNavbarLoading, changeIsMainLoading, setIsAuthentication} = authAction
            dispatch(changeIsNavbarLoading(true))
            try {
                const response = await extra.api.get('profile/self')
                if (!response.data.success) {
                    return rejectWithValue('error')
                }

                const info = response.data.response.info

                if (info?.user_group_id === UserGroup.Guest) {
                    await removeToken()
                    dispatch(setIsAuthentication(false))
                    return rejectWithValue('guest')
                }

                dispatch(setIsAuthentication(true))
                dispatch(fetchTwilioToken())
                return info
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue('error');
            } finally {
                dispatch(changeIsNavbarLoading(false))
                dispatch(changeIsMainLoading(false))
            }
        },
    );
